import { Outlet } from "react-router-dom";
import { Space, Input, Button, Splitter, Tabs } from "antd";
import { useState, useRef } from "react";

export const K8SNodesPage = () => {
  return (<div> Test Page - Nodes</div>);
} 

const TabContent = ({idx}) => {
  const [count1, setCount1] = useState(0);

  const ref = useRef(0);

  const handleClick = () => {
    ref.current = ref.current + 1;
    //alert('You clicked ' + ref.current + ' times!');
    setCount1(ref.current);
  };
  return (
    <Space direction="vertical">
      <Space.Compact block>
      New Tab Pane{idx}
      </Space.Compact>
      <Space.Compact style={{ width: '50%' }}>
        <Input value={count1}/>
        <Button type="primary" onClick={handleClick}>+</Button>
      </Space.Compact>
    </Space>
  );
};
const PropertySheet = () => {
  const [activeKey, setActiveKey] = useState();
  const [items, setItems] = useState([]);
  const newTabIndex = useRef(0);
  const onChange = (key) => {
    setActiveKey(key);
  };
  const add = () => {
    const newActiveKey = `newTab${newTabIndex.current++}`;
    setItems([
      ...items,
      {
        label: `New Tab${newTabIndex.current}`,
        children: <TabContent idx={newTabIndex.current}/>,
        key: newActiveKey,
      },
    ]);
    setActiveKey(newActiveKey);
  };
  const remove = (targetKey) => {
    const targetIndex = items.findIndex((pane) => pane.key === targetKey);
    const newPanes = items.filter((pane) => pane.key !== targetKey);
    if (newPanes.length && targetKey === activeKey) {
      const { key } = newPanes[targetIndex === newPanes.length ? targetIndex - 1 : targetIndex];
      setActiveKey(key);
    }
    setItems(newPanes);
  };
  const onEdit = (targetKey, action) => {
    if (action === 'add') {
      add();
    } else {
      remove(targetKey);
    }
  };
  return (
    <div>
      <div
        style={{
          marginBottom: 16,
        }}
      >
        <Button onClick={add}>ADD</Button>
      </div>
      <Tabs
        hideAdd
        onChange={onChange}
        activeKey={activeKey}
        type="editable-card"
        onEdit={onEdit}
        items={items}
      />
    </div>
  );
}

export const K8SContainer =  ({ children }) => {

  return (
    <Splitter style={{ height: '100%' }} layout="vertical">
      <Splitter.Panel collapsible min="20%">
        { children }
      </Splitter.Panel>
      <Splitter.Panel collapsible>
        <PropertySheet/>
      </Splitter.Panel>
  </Splitter>
  );
} 